export default __webpack_public_path__ + "static/media/sticker-w.3e99b0ea.png";